import React from "react";
import classes from "./Input.css";
const Input = (props) => {
  const inputClasses = [classes.Input];
  let error;
  if (props.error) {
    error = <span className={classes.ErrorMessage}>{props.error.message}</span>;
    inputClasses.push(classes.Error);
  }

  return (
    <div>
      <input
        onChange={props.changeHandler}
        value={props.value}
        type={props.type}
        className={inputClasses.join(" ")}
        placeholder={props.placeholder}
      />
      {error}
    </div>
  );
};

export default Input;
